<template>
  <div>
    <Modal
      class="onboarding"
      name="onboarding-modal"
      align="center"
      ref="modal"
    >
      <div class="onboarding__item" v-show="active === 1">
        <div class="modal__heading modal__item">
          <div class="modal__top-img">
            <img
              src="@/assets/img/illustrations/team-spirit-rafiki.svg"
              alt=""
            >
          </div>
          <h3 class="modal__title">Встречайте «Клубы»</h3>
          <div class="modal__subtitle">Станьте частью спортивного сообщества — выбирайте среди 100+&nbsp;спортивных клубов или создайте собственный</div>
        </div>
        <div class="modal__heading modal__item">
          <button class="button button_primary button_lg" @click="setActive(2)">
            <span class="button__text">Дальше</span>
          </button>
        </div>
      </div>
      <div class="onboarding__item" v-show="active === 2">
        <div class="modal__heading modal__item">
          <div class="modal__top-img">
            <img
              src="@/assets/img/illustrations/online-personal-trainer-rafiki.svg"
              alt=""
            >
          </div>
          <h3 class="modal__title">Соревнуйтесь с&nbsp;одноклубниками</h3>
          <div class="modal__subtitle">Тренируйтесь с&nbsp;подключённым трекером активности, чтобы побороться за&nbsp;лидерство в&nbsp;еженедельных рейтингах</div>
        </div>
        <div class="modal__heading modal__item">
          <button class="button button_primary button_lg" @click="setActive(3)">
            <span class="button__text">Дальше</span>
          </button>
        </div>
      </div>
      <div class="onboarding__item" v-show="active === 3">
        <div class="modal__heading modal__item">
          <div class="modal__top-img">
            <img
              src="@/assets/img/illustrations/winners-rafiki.svg"
              alt=""
            >
          </div>
          <h3 class="modal__title">Побеждайте в&nbsp;чемпионатах</h3>
          <div class="modal__subtitle">Каждая ваша тренировка влияет на&nbsp;положение клуба в&nbsp;межклубных чемпионатах и на ваш личный рейтинг в&nbsp;чемпионатах внутри клуба.</div>
        </div>
        <div class="modal__heading modal__item" @click="close">
          <button class="button button_primary button_lg">
            <span class="button__text">Вперёд к клубам</span>
          </button>
        </div>
      </div>
      <div class="dots">
        <div
          class="dots__item"
          :class="{'dots__item_active' : i === active}"
          v-for="i in count"
          :key="i"
          @click="setActive(i)"
        ></div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Modal from '@/components/Modal.vue'

export default {
  name: 'Onboarding',
  components: {
    Modal
  },
  data () {
    return {
      active: 1,
      count: 3,
      modal: null,
      watched: [],
      isSet: false
    }
  },
  computed: {
    ...mapState('user', ['isAuthorized', 'userUpdated', 'user'])
  },
  methods: {
    ...mapActions('user', ['setOnboardingShown']),
    setActive (index) {
      this.active = index

      if (this.watched.indexOf(index) === -1) {
        this.watched.push(index)
      }

      if (this.watched.length === this.count) {
        this.setStatus()
      }
    },
    close () {
      this.modal.close()
    },
    init () {
      if (this.isAuthorized) {
        if (!this.user.onboardingShown) {
          this.open()
          return
        }
        this.setStatus()
      } else {
        const status = !!localStorage.getItem('clubsOnboardingViewed')
        if (!status) {
          this.open()
        }
      }
    },
    open () {
      this.setActive(1)
      this.modal.open()
      this.modal.$on('afterClose', this.setStatus)
    },
    setStatus () {
      if (this.isSet) {
        return
      }
      this.isSet = true
      localStorage.setItem('clubsOnboardingViewed', true)
      if (this.isAuthorized && !this.user.onboardingShown) {
        this.setOnboardingShown()
      }
    }
  },
  watch: {
    userUpdated: {
      handler (val) {
        if (val) {
          setTimeout(this.init, 1000)
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.modal = this.$refs.modal
  }
}
</script>

<style lang="scss">
  .dots {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    margin: 24px 0 -24px;

    &__item {
      flex: 0 0 auto;
      cursor: pointer;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin: 0 4px;
      background-color: map-get($color-neutral-black, 25);
      transition: $transition-default;

      &_active {
        background-color: $color-primary;
      }
    }
  }
</style>
